import { LimitCategoryTypes, LimitTypes } from "@data-types";

export function isDefinedCategory(abrv: string) {
	const abrvs = Object.values(categoryAbrvs.sportsBetting).concat(
		Object.values(categoryAbrvs.games)
	);
	return abrvs.includes(abrv);
}

export function getTypeFromCategoryAbrv(abrv: string) {
	if (Object.values(categoryAbrvs.sportsBetting).includes(abrv)) {
		return LimitCategoryTypes.SPORTS_BETTING;
	}

	return LimitCategoryTypes.GAMES;
}

export function getLinkedCategory(
	category: LimitCategoryTypes,
	type: LimitTypes
) {
	if (category == LimitCategoryTypes.GAMES) {
		return type == LimitTypes.DEPOSIT
			? categoryAbrvs.games.deposit
			: categoryAbrvs.games.loss;
	}

	return type == LimitTypes.DEPOSIT
		? categoryAbrvs.sportsBetting.deposit
		: categoryAbrvs.sportsBetting.loss;
}

export function getCategoryTitleForDe(abrv: string) {
	if (abrv === categoryAbrvs.sportsBetting.loss) {
		return "my-limits:SPORTS_BETTING";
	}

	if (abrv === categoryAbrvs.games.deposit) {
		return "my-limits:LIMIT_CATEGORY.games-deposit";
	}
	if (abrv === categoryAbrvs.games.loss) {
		return "my-limits:LIMIT_TYPES.games-loss-limit-de";
	}

	return `my-limits:LIMIT_CATEGORY.${abrv}`;
}

export function getCategoryTitle(abrv: string) {
	return `my-limits:LIMIT_CATEGORY.${abrv}`;
}

export const categoryAbrvs = {
	sportsBetting: {
		deposit: "deposit",
		loss: "sports-betting",
	},
	games: {
		deposit: "games-deposit",
		loss: "online-casino",
	},
	casino: {
		deposit: "casino-deposit",
	},
	liveCasino: {
		deposit: "live-casino-deposit",
		limits: "live-casino",
	},
};
export function getFirstDescriptionItem(abrv: string, defaultValue: string) {
	if (
		WEBPACK_PUBLIC_THEME == "twdk" ||
		WEBPACK_PUBLIC_THEME == "twdk-mobile"
	) {
		if (abrv === categoryAbrvs.liveCasino.deposit) {
			return "my-limits:LIMIT_CATEGORY.live-casino-deposit";
		}
		return defaultValue;
	}
	if (
		WEBPACK_PUBLIC_THEME == "twse" ||
		WEBPACK_PUBLIC_THEME == "twse-mobile"
	) {
		if (abrv === categoryAbrvs.casino.deposit) {
			return "my-limits:LIMIT_CATEGORY.casino-deposit";
		}
		return defaultValue;
	}
	if (
		WEBPACK_PUBLIC_THEME == "twde" ||
		WEBPACK_PUBLIC_THEME == "twde-mobile" ||
		WEBPACK_PUBLIC_THEME == "twde-games" ||
		WEBPACK_PUBLIC_THEME == "twde-games-mobile"
	) {
		if (abrv === categoryAbrvs.sportsBetting.loss) {
			return "my-limits:SPORTS_BETTING";
		}
		return defaultValue;
	}
	if (abrv === categoryAbrvs.sportsBetting.loss) {
		return "my-limits:LOSS_LIMIT_TAB_TITLE";
	}

	if (abrv === categoryAbrvs.games.loss) {
		return "my-limits:GAMES_LOSS_LIMIT_TAB_TITLE";
	}

	return defaultValue;
}

export const LOGIN_LIMIT_TIME_ABRV = "login-time";
